import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SummaryService } from '../lead.service';
import { Summary, SummaryForm } from '../model/model.lead';

@Component({
  selector: 'app-assignlead',
  templateUrl: './assignlead.component.html',
  styleUrls: ['./assignlead.component.css']
})
export class AssignleadComponent implements OnInit {

  public keydata: number = parseInt(sessionStorage.getItem('userid'));
  public form: FormGroup;
  public summaryForm: SummaryForm;
  public leadagentList = [];
  public statelist = [];
  public countylist = [];
  public citylist = [];
  public ziplist = [];
  public scriptlist = [];
  public leadstagelist = [];
  public dispolist = [];
  dialerlist: any[] = []
  campaignsIds: any[] = []
  

  freeleads: number = 0
  allleads: number = 0
  

  CampIds: any[] = []
  Dialers: any[] = []

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<Summary>, protected router: Router, protected msg: MatSnackBar, protected fb: FormBuilder, private summaryService: SummaryService) {
    console.log(data);
  }

  ngOnInit() {
    console.log("this.data::", this.data)

    if (this.data) {
      console.log("this.data.leads::", this.data.leads);

      this.summaryForm = new SummaryForm(null);
      this.summaryForm.agent_type = 0;
      this.form = this.summaryForm.makeform(this.fb);
      console.log(this.form);
      console.log(this.summaryForm);

      // @dialer mapping
      if (sessionStorage.getItem("allcampaign")) {
        this.dialerlist = JSON.parse(sessionStorage.getItem("allcampaign"))
        for (let x of this.dialerlist) {
          this.CampIds.push(x.id)
          x['lead_type'] = []
          x['lead_status'] = []
          x['dispositions'] = []
          x['isAct'] = false
        }
      }

      // @loading the lead's scripts
      this.summaryService.getScripts(this.CampIds.join()).subscribe(res => {
        console.log("res", res)
        let lead_type: any = res || []
        for (let x of this.dialerlist) {
          for (let y of lead_type) {
            if (x.id == y.id_campaign) {
              x.lead_type.push(y)
            }
          }
        }
        console.log("this.dialerlist_1::", this.dialerlist)
      }, err => {
        console.log("err::", err)
      })

      // @loading the lead's stages
      this.summaryService.GetCrmWorkflows(this.CampIds.join()).subscribe(res => {
        console.log("res", res)
        let lead_status: any = res || []
        for (let x of this.dialerlist) {
          for (let y of lead_status) {
            if (x.id == y.id_campaign) {
              let Ab: any = y.description && y.description.length > 0 ? JSON.parse(y.description) : []
              x.lead_status = Ab
            }
          }
        }
        console.log("this.dialerlist_2::", this.dialerlist)
      }, err => {
        console.log("err::", err)
      })

      // @loading the lead's dispositions
      this.summaryService.GetCustomDisposition(this.CampIds.join()).subscribe(res => {
        console.log("res", res)
        let dispositions: any = res || []
        for (let x of this.dialerlist) {
          for (let y of dispositions) {
            if (x.id == y.id_campaign) {
              x.dispositions.push(y)
            }
          }
        }
        console.log("this.dialerlist_3::", this.dialerlist)
      }, err => {
        console.log("err::", err)
      })

      this.summaryService.getOption('leadagent').subscribe(res => {
        //console.log(res);
        if (this.data.type == 2) {
          if (this.keydata != this.data.fromagent)
            this.leadagentList.push({ id: this.keydata, first_name: sessionStorage.getItem('fullname'), last_name: "", type: 4, email: sessionStorage.getItem('email') });

          res.forEach((ele: any) => {
            console.log(ele);
            if (ele.id != this.data.fromagent)
              this.leadagentList.push(ele);
          });
        }
        else
          this.leadagentList = res;
      });
      console.log("this.leadagentList::", this.leadagentList);
      this.summaryService.getStateOption().subscribe(res => {
        console.log("State Option list called");
        console.log(res);
        this.statelist = res;
      })

      // @get lead counts
      this.summaryService.gettotallead().subscribe(res => {
        console.log(res)
        if (res != null) {
          this.freeleads = res[0].totallead
          this.allleads = res[0].allleads
          this.data.leads = this.freeleads
        }
      })

      this.enCmp({id:sessionStorage.getItem("currcampaign"),checked:true});
      

    }
// >>>>>>>>
    this.pastDate();
  }
  min:any = ""

  pastDate(){
    var tdate = new Date();
    var  date = tdate.getDate();
    if(date < 10){
      date = 0 + date;
    }
 
    var month:any = tdate.getMonth() + 1;
    if(month < 10){
      month = '0'+ month;
    }
 
    var year:any = tdate.getFullYear();
    this.min = year + "-" + month + "-" + date;
       console.log(this.min);
    
   }

//  >>>>>>>>

  get campIds(): any {
    if (sessionStorage.getItem("allcampaign")) {
      return JSON.parse(sessionStorage.getItem("allcampaign"))
    }
    return []
  }

  onChangeState(event: any) {
    console.log(event);
    let request = [];
    event.value.forEach(row => {
      request.push("'" + row + "'");
    });

    console.log(request);
    if (request.length > 0) {
      this.summaryService.getCountyOption(request).subscribe(res => {
        this.countylist = res;
        this.form.controls['county'].setValue('');
        this.form.controls['city'].setValue('');
        this.form.controls['zip'].setValue('');
      })
    }
  }

  onChangeCounty(event: any) {
    let statearr = [];
    let countyarr = [];
    event.value.forEach(row => {
      var splitted = row.split("-");
      statearr.push("'" + splitted[0] + "'");
      countyarr.push("'" + splitted[1] + "'");
    });

    let request = { state: statearr, county: countyarr }
    if (countyarr.length > 0) {
      this.summaryService.getCityOption(request).subscribe(res => {
        this.citylist = res;
      })
    }
  }

  onChangeCity(event: any) {
    let statearr = [];
    let countyarr = [];
    let cityarr = [];
    event.value.forEach(row => {
      var splitted = row.split("-");
      statearr.push("'" + splitted[0] + "'");
      countyarr.push("'" + splitted[1] + "'");
      cityarr.push("'" + splitted[2] + "'");
    });
    let request = { state: statearr, county: countyarr, city: cityarr }
    if (countyarr.length > 0) {
      this.summaryService.getZipOption(request).subscribe(res => {
        this.ziplist = res;
      })
    }
  }

  updateAssignLead(): any {
    console.log(this.Dialers)
    console.log(this.Dialers.length)
    if(this.Dialers.length < 1)
    {
      for (let i = 0; i < this.campaignsIds.length; i++) {
        this.Dialers.push({disposition: ['fresh'],
        id_dialer: this.campaignsIds[i],
        id_leadstatus: -1,
        lead_type: -1
        })
      }
    }
    if (this.campaignsIds.length == 0) {
      alert("Kindly select atleast 1 dialer to assign the leads.")
      return false
    }

    if (this.data.leads == 0) {
      alert("You have not insufficient leads to assign!")
      return false
    }

    if (this.form.value.agent_type == 0) {
      alert("Select any agent to assign the leads!")
      return false
    }

    console.log("this.form::", this.form.getRawValue())
     if (this.summaryForm.assign_lead == 0) {
      alert("You have entered insufficient leads!")

    

    } else if (this.summaryForm.assign_lead <= this.data.leads) {
      this.mapClose({
        fromdata: this.form,
        campaignsIds: this.campaignsIds,
        Dialers: this.Dialers
      })
    } else {
      alert("You have entered insufficient leads!\nYou have only " + this.data.leads + " leads.")
    } 
  }

  ReAssignLead() {
    console.log("this.campaignsIds.length",this.campaignsIds.length);    
    if (this.campaignsIds.length == 0) {
      alert("Kindly select atleast 1 dialer to assign the leads.")
      return false
    }
    if (this.data.leadss == 0) {
      alert("You have not insufficient leads to assign!")
      return false
    }
    if (this.data.fromagent == 0) {
      alert("Select any agent to assign the leads!")
      return false
    }

    console.log("this.form::", this.form.getRawValue())    
    if (this.summaryForm.assign_lead == 0) {
      alert("You have entered insufficient leads!")
    } else if (this.summaryForm.assign_lead <= this.data.leadss) {
      this.mapClose({
        fromdata: this.form,
        fromagent: this.data.fromagent,
        campaignsIds: this.campaignsIds,
        Dialers: this.Dialers
      })
    } else {
      alert("You have entered insufficient leads!\nYou have only " + this.data.leads + " leads.")
    }
  }

  mapClose(sdata: any) {
    console.log(sdata);
    this.dialogRef.close(sdata);
    
  }

  Close() {
    this.dialogRef.close();
  }

  /** @New functions **/
  enCmp(e: any): void {
    console.log("e::", e)
    if (e) {
      let id_dialer = e.id
      console.log("id_dialer::", id_dialer)

      let Index: any = this.dialerlist.findIndex((ele: any) => {
        return ele.id == id_dialer
      })

      if (Index > -1) {
        if (e.checked == true) {
          this.dialerlist[Index].isAct = true
          this.campaignsIds.push(id_dialer)
        } else {
          this.dialerlist[Index].isAct = false
          let index = this.campaignsIds.indexOf(id_dialer)
          if (index > -1) {
            this.campaignsIds.splice(index, 1)
          }
        }
      }
      this.campaignsIds.sort()

      if (e.checked == false) {
        let Index: any = this.Dialers.findIndex((ele: any) => {
          return ele.id_dialer == id_dialer
        })

        if (Index > -1) {
          this.Dialers.splice(Index, 1)
        }

        // It will make live filter on available leads
        this.getFilter()
      }
      console.log( this.Dialers)
    }
  }

  // @To select lead_script, lead_status and disposition dialer-wise
  SetFilter(e: any, id_campaign: number, type: number): void {
    console.log("e::", e.value)
    console.log("e::", type)

    // It will set lead scripts
    if (type == 1) {
      let Index: any = this.Dialers.findIndex((ele, i) => {
        return ele.id_dialer === id_campaign
      })
      console.log("Index::", Index)

      if (Index > -1) {
        this.Dialers[Index].lead_type = e.value
      } else {
        this.Dialers.push({
          id_dialer: id_campaign,
          lead_type: e.value,
          id_leadstatus: -1,
          disposition: []
        })
      }
      console.log("this.Dialers::", this.Dialers)
    }

    // It will set lead status
    if (type == 2) {
      let Index: any = this.Dialers.findIndex((ele, i) => {
        return ele.id_dialer === id_campaign
      })
      console.log("Index::", Index)
      if (Index > -1) {
        this.Dialers[Index].id_leadstatus = e.value
      } else {
        this.Dialers.push({
          id_dialer: id_campaign,
          lead_type: -1,
          id_leadstatus: e.value,
          disposition: []
        })
      }
      console.log("this.Dialers::", this.Dialers)
    }

    // It will set lead dispositions
    
    if (type == 3) {
      let Index: any = this.Dialers.findIndex((ele, i) => {
        return ele.id_dialer === id_campaign
      })
      console.log("Index::", Index)
      if (Index > -1) {
        this.Dialers[Index].disposition = e.value
      } else {
        this.Dialers.push({
          id_dialer: id_campaign,
          lead_type: -1,
          id_leadstatus: -1,
          disposition: e.value
        })
      }
      console.log("this.Dialers::", this.Dialers)
    }

    // It will make live filter on available leads
    this.getFilter()
  }

  // @custom function to make filter
  getFilter(e: any = null): void {
    console.log("Lead filter applied::")
    console.log("e::", e)

    this.summaryService.AssignLeadFilter(JSON.stringify({
      formdata: this.form.value,
      campaignsIds: this.campaignsIds,
      Dialers: this.Dialers
    })).subscribe(res => {
      console.log("res::", res)

      this.data.leads = 0
      if (res.error == 0) {
        if (res.data && res.data != null && res.data.length > 0) {
          this.data.leads = res.data[0].total_lead
        }
      }
    }, err => {
      console.log("err::", err)
    })
  }

 
 

}
